import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Fair } from '@planone/bau365/data-access-fair-data';
import { Exhibitor } from '@planone/bau365/util-fair-data';
import { combineTags, Tag } from '@planone/shared/util-interfaces';

@Component({
  selector: 'bau365-exhibitor-section-info',
  templateUrl: './section-info.component.html',
  styleUrls: ['./section-info.component.scss'],
})
export class SectionExhibitorInfoComponent implements OnChanges {
  @Input() exhibitor?: Exhibitor;
  @Input() fair?: Fair;
  @Input() chipsListClickable = true;

  tags: Tag[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['exhibitor']) {
      if (this.exhibitor?.is_startup) {
        this.tags = [
          {
            name: $localize`:@@featureExhibitors-tags-startup:Startup`,
            id: 'startup',
            filter: {
              startup: ['YES'],
            },
          },
          ...combineTags(this.exhibitor?.topics, this.exhibitor?.product_groups, this.exhibitor?.professions),
        ];
      } else {
        this.tags = combineTags(this.exhibitor?.topics, this.exhibitor?.product_groups, this.exhibitor?.professions);
      }
    }
  }
}
